import { DynamoDBClient, GetItemCommand, PutItemCommand } from '@aws-sdk/client-dynamodb'
import { marshall, unmarshall } from '@aws-sdk/util-dynamodb'
import crypto from 'crypto'
import { type CreateDrapeRequest, type DrapeRequest, drapeRequestSchema } from './schema'

export class DrapeRequestRepository {
  private client: DynamoDBClient
  private tableName = 'drape_requests'

  constructor() {
    this.client = new DynamoDBClient({})
  }

  async create(request: CreateDrapeRequest) {
    const id = crypto.randomUUID()
    const created_at = new Date().toISOString()

    const command = new PutItemCommand({
      TableName: this.tableName,
      Item: marshall({
        id,
        ...request,
        created_at,
      }),
    })

    await this.client.send(command)

    return { id }
  }

  async getById(id: string): Promise<DrapeRequest | null> {
    const command = new GetItemCommand({
      TableName: this.tableName,
      Key: marshall({ id }),
    })

    const result = await this.client.send(command)

    if (!result.Item) {
      return null
    }

    return drapeRequestSchema.parse(unmarshall(result.Item))
  }
}
